import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from '@angular/router';
import {DataService} from 'src/app/shared/services/data.service';

@Injectable({
    providedIn: 'root',
})
export class OverrideDataGuard implements Resolve<any> {
    constructor(private dataService: DataService) {}

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
        // This only returns true because the map function on the api call sets up all the data needed,
        // so if the call succeeds it can just return true to tell the route guard to load.
        return this.dataService
            .getCurrentOverwrites()
            .toPromise()
            .then(() => true);
    }
}
